var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:round-directions-walk"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.71154 3.1599C9.49423 3.1599 10.1346 2.51456 10.1346 1.7258C10.1346 0.937036 9.49423 0.291687 8.71154 0.291687C7.92885 0.291687 7.28846 0.937036 7.28846 1.7258C7.28846 2.51456 7.92885 3.1599 8.71154 3.1599ZM6.07885 5.59789L4.25731 14.8551C4.16481 15.2925 4.50635 15.7084 4.95462 15.7084H5.01154C5.34596 15.7084 5.63058 15.4789 5.70885 15.1491L6.86154 9.97192L8.35577 11.406V14.9913C8.35577 15.3857 8.67596 15.7084 9.06731 15.7084C9.45865 15.7084 9.77885 15.3857 9.77885 14.9913V10.9471C9.77885 10.5527 9.62231 10.1799 9.33769 9.90738L8.28462 8.89634L8.71154 6.74518C9.51335 7.66901 10.6111 8.28048 11.8138 8.47328C12.2408 8.53781 12.625 8.19363 12.625 7.75622C12.625 7.40487 12.3688 7.11087 12.0202 7.05351C10.9387 6.87425 10.0421 6.2289 9.56538 5.38277L8.85385 4.23549C8.66169 3.92583 8.36646 3.69519 8.02099 3.58484C7.67552 3.47448 7.30235 3.49161 6.96827 3.63316L4.24308 4.79479C3.9853 4.90583 3.76558 5.09076 3.61124 5.32661C3.45691 5.56246 3.37476 5.83882 3.375 6.12134V7.82076C3.375 8.21514 3.69519 8.53781 4.08654 8.53781C4.47789 8.53781 4.79808 8.21514 4.79808 7.82076V6.09983L6.07885 5.59789Z",
    fill: "#626262"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoam);
export default __webpack_public_path__ + "static/media/roam.08bd892fdd74b44315e5993518da6d56.svg";
export { ForwardRef as ReactComponent };